import { useSelector } from 'react-redux'

import Warning from '@/components/util/feedback/Warning'
import { getSubscriptionOrder } from '@/ducks/subscriptionOrderReducer'

import './subscription-order-dealer-instructions.scss'

const SubscriptionOrderDealerInstructions = () => {
  const { dealer_instructions } = useSelector(getSubscriptionOrder)

  if (!dealer_instructions?.trim()) return null

  return <Warning className="subscription-order-dealer-instructions">{dealer_instructions}</Warning>
}

export default SubscriptionOrderDealerInstructions
